export const PasswordRequirements = () => (
  <div className="space-y-1 text-sm text-muted-foreground">
    <p>Password must include:</p>
    <ul className="list-disc space-y-1 pl-5">
      <li>Between 8-30 characters</li>
      <li>At least one upper and one lower case letter</li>
      <li>At least one number</li>
      <li>At least one special character</li>
    </ul>
  </div>
);
